// @flow
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import * as r from 'ramda';

import { getDst, getDomainFilters } from '../../../domain/selectors';
import Filters from './Filters';

const mapStateToProps = (state) => {
  const filters = getDomainFilters(state);

  return {
    minTldLength: getDst(state).minTldLength,
    isUnspun: r.equals(filters.unspun, true),
  };
};

const mapDispatchToProps = r.always({});

export const enhance = compose(
  setDisplayName('ConnectedFilters'),
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Filters);
